<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <label>Data Inicial</label>
      <b-form-datepicker
        locale="pt-br"
        reset-button
        placeholder="Seleciona a data"
        v-model="form.dt_vigencia_ini"
        class="form-control"
        :disabled="isDisabledInput"
        :date-format-options="{
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
        }"
      >
      </b-form-datepicker>
      <label>Data Final</label>
      <b-form-datepicker
        locale="pt-br"
        reset-button
        placeholder="Seleciona a data"
        v-model="form.dt_vigencia_fim"
        class="form-control"
        :date-format-options="{
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
        }"
      >
      </b-form-datepicker>
      <label>Alíquota Contribuinte</label>
      <currency-input
        class="form-control"
        v-model="form.aliquota_contribuinte"
        :auto-decimal-mode="true"
        placeholder="Alíquota contribuinte"
        :currency="{ prefix: '%' }"
        :distraction-free="getCurrency"
        :disabled="isDisabledInput"
      />
      <b-form-feedback
        class="text-danger"
        v-text="form.errors.get('aliquota_contribuinte')"
        v-if="form.errors.has('aliquota_contribuinte')"
      ></b-form-feedback>

      <label>Alíquota Não Contribuinte</label>
      <currency-input
        class="form-control"
        v-model="form.aliquota_nao_contribuinte"
        :auto-decimal-mode="true"
        placeholder="Alíquota não contribuinte"
        :currency="{ prefix: '%' }"
        :distraction-free="getCurrency"
        :disabled="isDisabledInput"
      />
      <b-form-feedback
        class="text-danger"
        v-text="form.errors.get('aliquota_nao_contribuinte')"
        v-if="form.errors.has('aliquota_nao_contribuinte')"
      ></b-form-feedback>
      <label>Alíquota FCP</label>
      <currency-input
        class="form-control"
        v-model="form.aliquota_pobreza"
        :auto-decimal-mode="true"
        placeholder="Alíquota FCP"
        :currency="{ prefix: '%' }"
        :distraction-free="getCurrency"
        :disabled="isDisabledInput"
      />
      <b-form-feedback
        class="text-danger"
        v-text="form.errors.get('aliquota_pobreza')"
        v-if="form.errors.has('aliquota_pobreza')"
      ></b-form-feedback>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="primary"
          :disabled="isDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";
import moment from "moment";

export default {
  components: {
    AvisoErros
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: ""
  },
  data() {
    return {
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalGrupo: false,
      isFullscreen: false,
      isLoadingPessoa: false,
      aliquota_iss: 0,
      aliquota_contribuinte: 0,
      aliquota_nao_contribuinte: 0,
      aliquota_pobreza: 0,
      dt_vigencia_ini: "",
      dt_vigencia_fim: "",
      optionsLivStatus: [],
      statusSelected: [],
      errors_array: [],
      dt_inicio: "",
      dt_fim: "",
      isDisabledInput: false,
      helpForm: new Form({
        statusRecord: [],
        params: []
      }),
      form: new Form({
        status: 1,
        dt_vigencia_ini: "",
        dt_vigencia_fim: "",
        icms_id: "",
        icmsvig_id: "",
        aliquota_contribuinte: 0,
        aliquota_nao_contribuinte: 0,
        aliquota_pobreza: 0
      }),
      fields: [],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger"
      },
      moreParams: {}
    };
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.icmsvig_id);
      }
    },
    onCreate(data) {
      this.isDisabledInput = false;
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.errors_array = "";
      this.errors_array = [];
      this.form.icms_id = data.icms_id;
      this.form.status = 1;
      this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
      this.isDisabledInput = true;
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Editar Vigencia";
      this.modal_botao = "Atualizar";
      this.modal_acao = "u";
      this.form.reset();
      this.errors_array = "";
      this.errors_array = [];
      this.form.icms_id = data.icms_id;
      this.form.icmsvig_id = data.icmsvig_id;
      this.form.dt_vigencia_ini = data.dt_vigencia_ini;
      this.form.dt_vigencia_fim = data.dt_vigencia_fim;
      this.form.aliquota_contribuinte = data.aliquota_contribuinte;
      this.form.aliquota_nao_contribuinte = data.aliquota_nao_contribuinte;
      this.form.aliquota_pobreza = data.aliquota_pobreza;
      this.form.status = 1;
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.dt_vigencia_ini_label = this.form.dt_vigencia_ini;
      this.dt_vigencia_fim_label = this.form.dt_vigencia_fim;
      this.form
        .put("/api/icms/vigencia/store")
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.$parent.$refs.vuetable.reload();
          }
        })
        .catch(errors => {
          this.form.dt_vigencia_ini = this.dt_vigencia_ini_label;
          this.form.dt_vigencia_fim = this.dt_vigencia_fim_label;
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.dt_vigencia_ini_label = this.form.dt_vigencia_ini;
      this.dt_vigencia_fim_label = this.form.dt_vigencia_fim;
      this.form
        .patch("/api/icms/vigencia/update/" + id)
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.$parent.$refs.vuetable.reload();
          }
        })
        .catch(errors => {
          this.form.dt_vigencia_ini = this.dt_vigencia_ini_label;
          this.form.dt_vigencia_fim = this.dt_vigencia_fim_label;
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/icms/statusvigencia")
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.$parent.$refs.vuetable.reload();
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    formatDate(value, fmt = "D/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    }
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      }
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      }
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    }
  }
};
</script>
